// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@insite/content-library/Widgets/Budget/BudgetManagementHeader";
import { xButtonSharedStyles } from "@werner/App/SharedStyle/Common/ButtonsSharedStyles";
import { css } from "styled-components";

headerStyles.titleGridItem = {
    width: [10, 9, 7, 5, 6],
};
headerStyles.buttonsGridItem = {
    ...headerStyles.buttonsGridItem,
    width: [2, 3, 5, 7, 6],
    css: css`
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 10px;
    `,
};
headerStyles.actionButtonsHidden = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        max-width: unset;
    `,
};

headerStyles.assignBudgetsButton = {
    variant: "secondary",
};

headerStyles.costCodesButton = {
    variant: "secondary",
};
headerStyles.configureBudgetsButton = {
    css: css`
        white-space: nowrap;
    `,
};
